import { compose, css } from '@wrisk/styled-system'
import React, { FunctionComponent, ReactNode, useCallback } from 'react'
import styled from 'styled-components'

import { LinkAnchor, TypoSizeProps, typoSizes } from '../atoms'
import { withDefaultProps } from '../defaultProps'
import { HelpLinkIFrame } from './HelpLinkIFrame'
import { useModal } from './Modal'

export interface HelpLinkProps extends TypoSizeProps {
  linkText: ReactNode
  link: string
  isOpenModal?: boolean
  className?: string
}

const Component: FunctionComponent<HelpLinkProps> = ({
  link,
  linkText,
  className,
  isOpenModal = true,
  ...props
}) => {
  const modal = useModal()

  const openModal = useCallback(
    () =>
      modal.show({
        content: <HelpLinkIFrame src={link} />,
        variant: 'iframe',
      }),
    [link, modal],
  )

  const helpLink = isOpenModal ? (
    <LinkAnchor
      variant='standalone'
      target='_blank'
      className={className}
      href={link}
      onClick={openModal}
      {...props}
    >
      {linkText}
    </LinkAnchor>
  ) : (
    <LinkAnchor
      variant='standalone'
      target='_blank'
      className={className}
      href={link}
      {...props}
    >
      {linkText}
    </LinkAnchor>
  )

  return <>{helpLink}</>
}

const defaultProps = withDefaultProps<HelpLinkProps>({
  typoSize: 'sm',
})

export const HelpLink = styled(Component).attrs<HelpLinkProps>(defaultProps)(
  css({
    color: 'hyperlink',
    fontFamily: 'buttons',
    fontWeight: 'bold',
  }),
  compose(typoSizes),
)
